import { useEffect, useState } from 'react';
import { getSession, onAuthChange } from '../../lib/adminAuth';

/**
 * Correo del administrador autenticado (o `null` mientras se resuelve o
 * si no hay sesión). `ProtectedAdminRoute` ya garantiza que quien llega
 * hasta aquí tiene sesión válida, así que este hook solo expone el
 * correo -para derivar el nombre visible en la topbar y el saludo del
 * dashboard (ver `deriveDisplayName`)-, actualizándolo cuando la sesión
 * cambia (logout manual, expiración por inactividad, otra pestaña...).
 */
export default function useAdminSession() {
  const [email, setEmail] = useState(null);

  useEffect(() => {
    let active = true;

    const applyEmail = session => {
      if (!active) return;
      setEmail(session?.user?.email ?? null);
    };

    getSession().then(applyEmail);

    const unsubscribe = onAuthChange(applyEmail);

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return { email };
}
